"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    assessmentInstanceItem: {
        students: 'Students',
        allStudents: 'All Students',
        item: 'Item',
        assessmentReport: 'assessment report',
    },
};
